var Application;

Application = {
    ready: function () {

        this.Forms.ready();
        this.DatePicker.ready();
        this.LangMenu.init();

    },
    LangMenu: {
        init: function(){

            var $elem = $('.lang-switcher-toggle'),
                $container = $('.lang-switcher'),
                $clActive = 'active';

            $container.hover(function(e){
                e.preventDefault();
                $container.addClass($clActive);
            },function(e){
                e.preventDefault();
                $container.removeClass($clActive);
            });

            $elem.on({ 'touchstart' : function(e){
                    e.preventDefault();
                    $container.toggleClass($clActive);
                }
            });

            $(document).mouseup(function (e) {
                var container = $container,
                    exceptions = $elem;
                if (!container.is(e.target) && container.has(e.target).length === 0 && !exceptions.is(e.target)){
                    $container.removeClass($clActive);
                }
            });

        }
    }
};

// Initiate the application
jQuery(function () {
    Application.ready();
});